"use client";

import cnBind from "classnames/bind";
import { Accordion, AccordionTab } from "primereact/accordion";
import { useTranslation } from "react-i18next";

import { useOptionalIndustryPreset } from "@/components/landing/IndustryPresetContext";
import { BEAUTY_CAMPAIGN_FAQ, isCampaignVisible, type PublicCampaign } from "@/shared/campaign/beautyCampaign";

import styles from "./Faq.module.scss";

const cx = cnBind.bind(styles);

type FaqItem = { question: string; answer: string };

export const Faq = ({ campaign }: { campaign?: PublicCampaign | null }) => {
    const { t } = useTranslation("common");
    const industry = useOptionalIndustryPreset();
    const homeItems = t("home.faq.items", { returnObjects: true }) as FaqItem[];
    const items: FaqItem[] =
        industry?.activePreset === "beauty" && isCampaignVisible(campaign)
            ? [...BEAUTY_CAMPAIGN_FAQ, ...(Array.isArray(homeItems) ? homeItems : [])]
            : Array.isArray(homeItems)
              ? homeItems
              : [];

    return (
        <section className={cx("faq")} id="faq" aria-labelledby="home-faq-title">
            <div className={cx("wrapper", "container")}>
                <div className={cx("header")}>
                    <span>{t("home.faq.eyebrow")}</span>
                    <h2 id="home-faq-title">{t("home.faq.title")}</h2>
                </div>

                <Accordion className={cx("list")}>
                    {items.map((tab) => (
                        <AccordionTab key={tab.question} header={tab.question} className={cx("item")}>
                            <p className={cx("desc")}>{tab.answer}</p>
                        </AccordionTab>
                    ))}
                </Accordion>
            </div>
        </section>
    );
};
